export default {
  "content": "<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#FFD5E3\"/><path d=\"M22.522 13.727c.902.347 1.548 1.262 1.548 2.34 0 1.078-.646 1.993-1.548 2.34m-8.825 1.57v-7.824M13 23.773l-1.707-3.415M22.062 7.53s-2.343 4.624-7.698 4.624H9.008c-1.104 0-2.008.96-2.008 2.134v3.556c0 1.174.904 2.134 2.008 2.134h5.356c5.355 0 7.698 4.624 7.698 4.624V7.529z\" stroke=\"#1D1D1B\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};